import { AlertCircle } from "lucide-react";
import styles from "../../styles/ui/Form.module.scss";

/**
 * The site's single form field: the label sits inside the field surface and
 * the whole shell reacts to hover/focus/error, so labels never read as
 * detached from their control.
 *
 * Renders an <input> by default; pass `as="select"` or `as="textarea"` with
 * children/options for the other control types.
 */
const Field = ({
  id,
  name,
  label,
  error,
  as = "input",
  className = "",
  children,
  ...control
}) => {
  const describedBy = error ? `${id}-error` : undefined;
  const Control = as;

  return (
    <div className={`${styles.group} ${className}`}>
      <div className={styles.field} data-invalid={error ? "true" : "false"}>
        <label htmlFor={id}>{label}</label>
        <Control
          id={id}
          name={name || id}
          aria-invalid={error ? "true" : "false"}
          aria-describedby={describedBy}
          {...control}
        >
          {children}
        </Control>
      </div>
      {error && (
        <p id={describedBy} className={styles.error}>
          <AlertCircle aria-hidden="true" />
          {error}
        </p>
      )}
    </div>
  );
};

export default Field;
